function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3678 15.2109C13.3678 15.7632 13.8155 16.2109 14.3678 16.2109C14.7252 16.2109 15.0388 16.0235 15.2156 15.7415L17.9033 13.0539C18.2938 12.6633 18.2938 12.0302 17.9033 11.6396C17.5127 11.2491 16.8796 11.2491 16.4891 11.6396L15.3678 12.7609L15.3678 5.21094C15.3678 4.65865 14.9201 4.21094 14.3678 4.21094C13.8155 4.21094 13.3678 4.65865 13.3678 5.21094L13.3678 15.1615C13.3677 15.1706 13.3677 15.1797 13.3678 15.1889V15.2109Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3996 9.21094C11.3996 8.65865 10.9519 8.21094 10.3996 8.21094C10.0422 8.21094 9.72863 8.39842 9.5518 8.6804L6.86418 11.368C6.47366 11.7585 6.47366 12.3917 6.86418 12.7822C7.25471 13.1728 7.88787 13.1728 8.2784 12.7822L9.39962 11.661L9.39962 19.2109C9.39962 19.7632 9.84734 20.2109 10.3996 20.2109C10.9519 20.2109 11.3996 19.7632 11.3996 19.2109L11.3996 9.26039C11.3997 9.25127 11.3997 9.24214 11.3996 9.23302V9.21094Z",
  fill: "#4979C0"
});

var SvgTransaction = function SvgTransaction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransaction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transaction.e4cd25ae.svg";
export { ForwardRef as ReactComponent };